import React from 'react';
import { FDBox, FDContentContainer } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const Layout = () => {
  return (
    <FDContentContainer maxWidth={'md'}>
      <FDBox>
        <FDBox paddingY={4}>
          <MetaControlField attr={'title'} />
        </FDBox>
        <MetaControlField attr={'sections'} />
      </FDBox>
    </FDContentContainer>
  );
};

export default Layout;
